import client from './client';

export const listBusinessReports = () => client.get('/business-report').then((r) => r.data);
export const getBusinessReport = (id) => client.get(`/business-report/${id}`).then((r) => r.data);
export const previewBusinessReport = () => client.get('/business-report/preview').then((r) => r.data);
export const buildBusinessReport = (notes) => client.post('/business-report/build', { notes }).then((r) => r.data);
export const submitBusinessGroup = (groupName, notes) =>
  client.post('/business-report/submit-group', { groupName, notes }).then((r) => r.data);
export const updateBusinessGroupNote = (id, body) =>
  client.patch(`/business-report/${id}/group-note`, body).then((r) => r.data);
export const getBusinessDraft = () => client.get('/business-report/draft').then((r) => r.data);
export const saveBusinessDraft = (body) => client.patch('/business-report/draft', body).then((r) => r.data);
